// extracted by mini-css-extract-plugin
export default {"list":"Companies-module--list--W1y+Z","item":"Companies-module--item--OfoSI"};